var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Table } from 'template/lib';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import api from '../../services/api';
import ModalAttendant from "../Modals/ModalAttendant";
import ModalConfirmation from "../Modals/ModalConfirmation";
import { FiPlus } from "react-icons/fi";
import { BsTrash } from "react-icons/bs";
import styles from './styles.module.scss';
import { FaEdit } from "react-icons/fa";
import ModalEditAttendant from '../Modals/ModalEditAttendant';
var Attendants = function () {
    var _a = useState(0), idToChange = _a[0], setIdToChange = _a[1];
    var _b = useState(0), idAttendant = _b[0], setIdAttendant = _b[1];
    var _c = useState([]), attendantState = _c[0], setAttendantState = _c[1];
    var _d = useAuth(), login = _d.login, handleLogout = _d.handleLogout;
    var _e = useState([]), attendants = _e[0], setAttendants = _e[1];
    var _f = useState(1), page = _f[0], setPage = _f[1];
    var _g = useState(0), totalPages = _g[0], setTotalPages = _g[1];
    var _h = useState(true), loading = _h[0], setLoading = _h[1];
    var _j = useState(10), pageSize = _j[0], setPageSize = _j[1];
    var _k = useState(false), refresh = _k[0], setRefresh = _k[1];
    var _l = useState(false), hasNext = _l[0], setHasNext = _l[1];
    var _m = useState(false), editSoftware = _m[0], setEditSoftware = _m[1];
    var _o = useState(false), softwareId = _o[0], setSoftwareId = _o[1];
    var setTitle = useTitle().setTitle;
    var history = useHistory();
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        setTitle('Atendentes');
        setLoading(true);
        if (login && Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.push('/');
            return;
        }
        if (!login) {
            history.push('/');
            return;
        }
        api.get("/attendants/get-total-pages?pageSize=" + pageSize, config)
            .then(function (response) {
            setTotalPages(response.data);
            setHasNext(response.data > page);
        });
        api.get("/attendants?page=" + page + "&pageSize=" + pageSize, config)
            .then(function (response) {
            setAttendants(response.data);
        })
            .finally(function () { return setLoading(false); });
    }, [refresh, page, pageSize]);
    useEffect(function () {
        if (idToChange === 0)
            return;
        api.put("/attendants/" + idToChange, attendantState, config).then(function () {
            setRefresh(function (prev) { return !prev; });
            setIdToChange(0);
        });
    }, [attendantState, idToChange]);
    var _p = useState(false), modalIsOpenAttendant = _p[0], setModalIsOpenAttendant = _p[1];
    function handleOpenModalAttendant() {
        setModalIsOpenAttendant(true);
    }
    function handleOpenModalAttendantEdit() {
        setEditSoftware(true);
    }
    function handleCloseModalAttendantEdit() {
        setEditSoftware(false);
        api.get("/attendants/get-total-pages?pageSize=" + pageSize, config)
            .then(function (response) {
            setTotalPages(response.data);
            setHasNext(response.data > page);
        });
        api.get("/attendants?page=" + page + "&pageSize=" + pageSize, config)
            .then(function (response) {
            setAttendants(response.data);
        })
            .finally(function () { return setLoading(false); });
    }
    function handleCloseModalAttendant() {
        setModalIsOpenAttendant(false);
    }
    var _q = useState(false), modalIsOpenConfirmationDeleteAttendant = _q[0], setModalIsOpenConfirmationDeleteAttendant = _q[1];
    function handleOpenModalConfirmationDeleteAttendant() {
        setModalIsOpenConfirmationDeleteAttendant(true);
    }
    function handleCloseModalConfirmationDeleteAttendant() {
        setModalIsOpenConfirmationDeleteAttendant(false);
    }
    var lineBtns = [
        {
            fn: function (id) {
                var attendant = attendants.find(function (x) { return x.id === id; });
                console.log(attendant === null || attendant === void 0 ? void 0 : attendant.softwareIds);
                setSoftwareId(attendant === null || attendant === void 0 ? void 0 : attendant.softwareIds);
                setIdAttendant(id);
                setEditSoftware(true);
            },
            icon: _jsx(FaEdit, { size: 16 }, void 0),
            name: 'Editar'
        },
        {
            fn: function (id) {
                setIdAttendant(id);
                handleOpenModalConfirmationDeleteAttendant();
            },
            icon: _jsx(BsTrash, { size: 16 }, void 0),
            name: 'Excluir'
        }
    ];
    var menuBtn = [
        {
            fn: function () {
                handleOpenModalAttendant();
            },
            icon: _jsx(FiPlus, { size: 16 }, void 0),
            id: 1,
            title: 'Novo Atendente'
        }
    ];
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: styles.container }, { children: _jsx(Table, { setSize: setPageSize, size: pageSize, hasNext: hasNext, page: page, setPage: setPage, data: attendants, setData: setAttendants, changeExistentContent: setAttendantState, totalPAges: totalPages, loading: loading, title: 'Atendentes', setIdToChange: setIdToChange, refresh: setRefresh, headerButtons: menuBtn, lineButton: lineBtns, editable: true, columns: [
                        { label: 'Nome', key: 'userName', disabled: true },
                        { label: 'Tipo', key: 'userGroupName', disabled: true },
                        { label: 'Ativo', key: 'select_active' },
                        { label: 'Softwares', key: 'softwareNames', disabled: true },
                    ] }, void 0) }), void 0), _jsx(ModalAttendant, { refresh: refresh, setRefresh: setRefresh, modalIsOpenAttendant: modalIsOpenAttendant, handleOpenModalAttendant: handleOpenModalAttendant, handleCloseModalAttendant: handleCloseModalAttendant }, void 0), _jsx(ModalEditAttendant, { idAttendant: idAttendant, modalIsOpenAttendant: editSoftware, handleOpenModalAttendantEdit: handleOpenModalAttendantEdit, handleCloseModalAttendantEdit: handleCloseModalAttendantEdit, idSoftware: softwareId }, void 0), _jsx(ModalConfirmation, { method: 'delete', url: "attendants/" + idAttendant, title: 'este atendente', refresh: refresh, setRefresh: setRefresh, modalIsOpenConfirmation: modalIsOpenConfirmationDeleteAttendant, handleOpenModalConfirmation: handleOpenModalConfirmationDeleteAttendant, handlecloseModalConfirmation: handleCloseModalConfirmationDeleteAttendant }, void 0)] }, void 0));
};
export default Attendants;
